const table108 = [
    {
        key: "entity_code",
        name: "法人コード",
        editable: false
    },
    {
        key: "entity_name",
        name: "法人名",
        editable: false
    },
    {
        key: "before_previous_period_business_or_consolidated_begin",
        name: "前々期_事業年度又は連結事業年度(期首)",
        editable: true,
        type: "date"
    },
    {
        key: "before_previous_period_business_or_consolidated_end",
        name: "前々期_事業年度又は連結事業年度(期末)",
        editable: true,
        type: "date"
    },
    {
        key: "before_previous_period_outstanding_begin",
        name: "前々期_期首現在未決済額",
        editable: true
    },
    {
        key: "before_previous_period_outstanding_paid",
        name: "前々期_当期中の決済額_支払額",
        editable: true
    },
    {
        key: "before_previous_period_outstanding_receivable",
        name: "前々期_当期中の決済額_受取額",
        editable: true
    },
    {
        key: "previous_period_business_or_consolidated_begin",
        name: "前期_事業年度又は連結事業年度(期首)",
        editable: true,
        type: "date"
    },
    {
        key: "previous_period_business_or_consolidated_end",
        name: "前期_事業年度又は連結事業年度(期末)",
        editable: true,
        type: "date"
    },
    {
        key: "previous_period_begin_outstanding",
        name: "前期_期首現在未決済額",
        editable: true
    },
    {
        key: "previous_period_settlement_current_period_payment",
        name: "前期_当期中の決済額_支払額",
        editable: true
    },
    {
        key: "previous_period_settlement_current_period_receivable",
        name: "前期_当期中の決済額_受取額",
        editable: true
    },
    {
        key: "current_period_occurred_incidental_amount_other",
        name: "当期分_当期発生額_附帯税_外",
        editable: true
    },
    {
        key: "current_period_incidental_tax_settlement_payment",
        name: "当期分_当期中の決済額_支払額_附帯税",
        editable: true
    },
    {
        key: "current_period_incidental_tax_settlement_payment_within",
        name: "当期分_当期中の決済額_支払額_附帯税_内",
        editable: true
    },
    {
        key: "current_period_qualified_merger_settlement_payment",
        name: "当期分_当期中の決済額_支払額_適格合併等",
        editable: true
    },
    {
        key: "current_period_incidental_tax_payment_receivable",
        name: "当期分_当期中の決済額_受取額_附帯税",
        editable: true
    },
    {
        key: "current_period_qualified_merger_payment_receivable",
        name: "当期分_当期中の決済額_受取額_適格合併等",
        editable: true
    }
];

export { table108 };
